import { accountService } from "../_services/accounts.service";
export interface IPrimaryNavInterface {
    icon: string;
    name: string;
    mobileName?: string;
    url: string;
    onClick?: any;
    png?: string;
}

const PRIMARY_NAV: IPrimaryNavInterface[] = [
    { icon: 'home', name: 'Dashboard', mobileName: 'Dashboard', url: '' },
    { icon: 'folder', name: 'Cases', mobileName: 'Cases', url: 'Cases' },
    { icon: 'confirmation_number', name: 'Tickets', mobileName: 'Tickets', url: 'Tickets' },
];


const ADMIN_NAV: IPrimaryNavInterface[] = [
    { icon: 'groups', name: 'Users', mobileName: 'Users', url: 'Users' },
    { icon: 'account_box', name: 'Clients', mobileName: 'Clients', url: 'Clients' },
    { icon: 'price_change', name: 'Client Price Bands', mobileName: 'Client Price Bands', url: 'ClientPriceBands' },
    { icon: 'checklist', name: 'Ticket Action List', mobileName: 'Ticket Action List', url: 'TicketActionList' },
    { icon: 'check', name: 'Action Type', mobileName: 'Action Type', url: 'ActionType' },
    { icon: 'content_copy', name: 'Ticket Status', mobileName: 'Ticket Status', url: 'TicketStatus' },
    { icon: 'fact_check', name: 'Closing Checklist', mobileName: 'Closing Checklist', url: 'ClosingChecklist' },
    { icon: 'check_box', name: 'Closing Checklist Items', mobileName: 'Closing Checklist Items', url: 'ClosingChecklistItems' },
    { icon: 'auto_delete', name: 'Purge Tickets', mobileName: 'Purge Tickets', url: 'ticketPurgeLog' },
    { icon: 'article', name: 'Form Templates', mobileName: 'Form Templates', url: 'FormTemplates' },
    { icon: 'savings', name: 'Xero', mobileName: 'Xero', url: 'Xero' },
    { icon: 'book', name: 'Logs', mobileName: 'Logs', url: 'Logs' },
    /*{ icon: 'sms', name: 'SMS Templates', mobileName: 'SMS Templates', url: 'SMSTemplates' }, //Not required but leaving here, just incase*/
];

const REPORTS_NAV: IPrimaryNavInterface[] = [
    { icon: 'description', name: 'Agent Summary Report', mobileName: 'Agent Summary Report', url: 'AgentSummaryReport' },
    { icon: 'receipt', name: 'Agent Invoice Summary Report', mobileName: 'Agent Invoice Summary Report', url: 'AgentInvoiceSummaryReport' },
    { icon: 'auto_awesome_motion', name: 'All Tickets Report', mobileName: 'All Tickets Report', url: 'AllTicketsReport' },
    { icon: 'delete_sweep', name: 'Purge Ticket Report', mobileName: 'Purge Ticket Report', url: 'PurgeTicketReport' }

];

const CLIENT_NAV: IPrimaryNavInterface[] = [
    { icon: 'folder', name: 'Cases', mobileName: 'Cases', url: 'Cases' },
    { icon: 'confirmation_number', name: 'Tickets', mobileName: 'Tickets', url: 'Tickets' },
];

const AGENT_NAV: IPrimaryNavInterface[] = [
    { icon: 'confirmation_number', name: 'Tickets', mobileName: 'Tickets', url: 'Tickets' },
];

const USER_NAV1: IPrimaryNavInterface[] = [
    { icon: 'groups', name: 'Agents', mobileName: 'Users', url: 'Users' },
];

const USER_NAV: IPrimaryNavInterface[] = [
    /*{ icon: 'logout', name: 'Log Out', url: 'logout', onClick: accountService.logout },*/
];

export {
    PRIMARY_NAV,
    ADMIN_NAV,
    USER_NAV,
    AGENT_NAV,
    REPORTS_NAV,
    CLIENT_NAV,
    USER_NAV1
};

